import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import Marquee from 'react-fast-marquee';

const StyledTicker = styled.div`
  .marquee {
    text-transform: uppercase;
    font-size: 60px;
    height: 60px;
    line-height: 1;
    overflow: hidden;
    font-family: var(--heading-font);
    font-weight: 600;
    background: var(--gradient);
    -webkit-background-clip: text;
    background-clip: text;
    text-fill-color: transparent;
    -webkit-text-fill-color: transparent;

    .icon {
      font-size: 20px;
      margin: 0 15px;
    }

    &-container {
      gap: 20px;
    }
  }

  &.error {
    .marquee-container {
      gap: 0 !important;
    }
  }

  @media screen and (min-width: 768px) {
    .marquee {
      font-size: 120px;
      height: 100px;

      .icon {
        font-size: 40px;
        margin: 0 30px;
      }

      &-container {
        gap: 30px;
      }
    }
  }

  @media screen and (min-width: 1170px) {
    .marquee {
      font-size: 200px;
      height: 165px;

      &-container {
        gap: 40px;
      }
    }

    &.error {
      .marquee-container {
        margin-top: -165px;
      }
    }
  }
`;

const Ticker = ({ text, isErrorPage = false }) => {
  const [speed, setSpeed] = useState(100);

  useEffect(() => {
    const updateSpeed = () => {
      if (window.innerWidth < 768) {
        setSpeed(30); // Slower speed for mobile devices
      } else {
        setSpeed(100); // Default speed for larger screens
      }
    };

    // Initial speed setting
    updateSpeed();

    // Update speed on window resize
    window.addEventListener('resize', updateSpeed);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', updateSpeed);
    };
  }, []);

  return (
    <StyledTicker className={isErrorPage ? 'error' : ''}>
      <Marquee gradient={false} speed={speed}>{text}</Marquee>
    </StyledTicker>
  );
};

export default Ticker;
